import { createStore } from '../_core/createStore';
import { sentryClient } from './clients/sentryClient';
import { errorReportingStore } from './errorReportingStore';

const useErrorReportingStore = createStore({
  creator: errorReportingStore(sentryClient),
  id: 'errorReporting',
  ignoreReset: true,
  middlewares: {
    devtools: true,
  },
});

export default useErrorReportingStore;
